// extracted by mini-css-extract-plugin
export default {"card":"PortfolioTypeItem_card__NAX2M","imageHolder":"PortfolioTypeItem_imageHolder__KfKJE","textHolder":"PortfolioTypeItem_textHolder__2Hy01"};